import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from './services/auth.service';
import {UserActions} from './store/actions/user.actions';
import {Angulartics2} from 'angulartics2';
import {environment} from '../environments/environment';
import {AdminService} from './services/admin.service';
import {UserService} from './services/user.service';
import {MdSnackBar} from '@angular/material';
import {UserIdle} from './routing/user-idle';

var idle: UserIdle;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private router: Router,
              private auth: AuthService,
              private userActions: UserActions,
              angulartics2: Angulartics2,
              public adminService: AdminService,
              private userService: UserService,
              private snackBar: MdSnackBar) {

    if (!environment.production) {
      angulartics2.developerMode(true);
    }

    idle = new UserIdle(this.router, this.auth, this.userActions, this.userService, this.snackBar);
    
  }

  ngOnInit() {

    /* Hack for CDK component overlay issue with MD2 & Material */
    setInterval(() => {
      if (document.querySelector('.cdk-overlay-container .mat-dialog-container')) {
        document.querySelector('.cdk-overlay-container .mat-dialog-container')
          .parentElement.parentElement.parentElement.style.zIndex = '999';
      }
    }, 200);

    idle.start();

  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts